import {createUseStyles} from 'react-jss';
import SkeletonBox from '../../UI/SkeletonBox/SkeletonBox';

const useStyles = createUseStyles({
  skeletonInputField: {
    marginTop: 16,
  },
  
  input: {
    marginTop: 4,
    marginBottom: 10,
  },
});

export function SkeletonInputField() {
  const classes = useStyles();
  
  return (
    <div className={classes.skeletonInputField}>
      <SkeletonBox height={23} width="50%" />
      <div className={classes.input}>
        <SkeletonBox height={42} />
      </div>
    </div>
  );
}

export default SkeletonInputField;
